import { connect } from 'react-redux';
import * as actionsManagement from '../../actions/management';
import * as actionsUMK from '../../actions/umk';
import { list } from '../../actions/faculty';
import { schoolYear } from '../../actions/report';
import IndividualWorkPlan from '../../components/individualWorkPlan/IndividualWorkPlan';
import {
    getIndividualPlan,
    getIndividualPlanFilters,
    getIndividualPlanMain,
    getIndividualPlanI,
    getIndividualPlanII,
    getIndividualPlanIII,
    getIndividualPlanIIIGroup,
    getIndividualPlanIIITimes,
    editIndividualPlanIII,
    addIndividualPlanI,
    editIndividualPlanI,
    deleteIndividualPlanI
} from '../../actions/individualWorkPlan';
import { cathList } from '../../actions/cathedra';
import * as LKactions from '../../actions/lk';

const mapStateToProps = ({ faculty, management, radar, report, cathedra, individualWorkPlan,
    layout, lk: { data, photo }, portfolio: { error, info }, auth: { isTeacher, mid }, umk: { group, disciplineList },
}) => ({
    management,
    faculties: management.faculty,
    cathedras: management.cathedra,
    years: report.scy,
    facultyList: faculty.list,
    individualWorkPlanList: individualWorkPlan.individualWorkPlanList,
    individualWorkPlanMain: individualWorkPlan.individualWorkPlanMain,
    individualWorkPlanTab: individualWorkPlan.individualWorkPlanTab,
    list: cathedra.list,
    user: data,
    photo,
    error,
    isTeacher,
    layout,
    group,
    portfolio: info,
    userId: mid,
    taskForYear: individualWorkPlan.taskForYear,
    academicWork: individualWorkPlan.academicWork,
    academicWorkGroup: individualWorkPlan.academicWorkGroup,
    filtersList: individualWorkPlan.filtersList

});

const mapDispatchToProps = dispatch => ({
    getYears: () => dispatch(schoolYear()),
    StudyYears: () => dispatch(schoolYear()),
    fetchFacultyList: () => dispatch(list()),
    getCathedra: (facultyId, isJournalAdmin) =>
        dispatch(actionsManagement.getCathedra(facultyId, true, isJournalAdmin)),
    getIndividualPlan: (state) => dispatch(getIndividualPlan(state)),
    getIndividualPlanFilters: (state) => dispatch(getIndividualPlanFilters(state)),
    getIndividualPlanMain: (id) => dispatch(getIndividualPlanMain(id)),
    getIndividualPlanII: (id) => dispatch(getIndividualPlanII(id)),
    getCathList: (id) => dispatch(cathList(id)),
    didMount: () => dispatch(LKactions.lk()) && dispatch(LKactions.photo()) && dispatch(actionsUMK.umk()),

    getIndividualPlanI: (id) => dispatch(getIndividualPlanI(id)),
    addIndividualPlanI: (data, id) => dispatch(addIndividualPlanI(data, id)),
    editIndividualPlanI: (data) => dispatch(editIndividualPlanI(data)),
    deleteIndividualPlanI: (conf, data) => dispatch(deleteIndividualPlanI(conf, data)),
    getIndividualPlanIII: (params) => dispatch(getIndividualPlanIII(params)),
    getIndividualPlanIIITimes: (params) => dispatch(getIndividualPlanIIITimes(params)),
    getIndividualPlanIIIGroup: (params) => dispatch(getIndividualPlanIIIGroup(params)),
    editIndividualPlanIII: (params) => dispatch(editIndividualPlanIII(params))

});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(IndividualWorkPlan);
